import { Checkbox, InputLabel, type InputLabelProps, type Theme } from '@mui/material';
import { type SystemStyleObject } from '@mui/system';
import { type ChangeEvent, type InputHTMLAttributes } from 'react';

export type InputLabelWithCheckboxProps = Omit<InputLabelProps, 'onChange' | 'sx'> & {
  checked: boolean;
  inputProps?: InputHTMLAttributes<HTMLInputElement>;
  onChange: (event: ChangeEvent<HTMLInputElement>, checked: boolean) => void;
  sx?: SystemStyleObject<Theme>;
};

export const InputLabelWithCheckbox = ({
  checked,
  children,
  disabled,
  inputProps = {},
  onChange,
  sx = {},
  ...rest
}: InputLabelWithCheckboxProps) => (
  <InputLabel
    sx={{ color: 'inherit', marginBottom: theme => theme.spacing(1), marginTop: theme => theme.spacing(2), ...sx }}
    {...rest}
  >
    {children}
    <Checkbox
      checked={checked}
      onChange={onChange}
      slotProps={{
        input: { 'aria-label': `${disabled ? 'Enable' : 'Disable'} range slider`, ...inputProps },
      }}
      sx={{
        '&.Mui-checked': {
          color: theme => theme.palette.primary.main,
        },
        color: theme => theme.palette.grey[400],
      }}
    />
  </InputLabel>
);
